import classnames from 'classnames';
import React from 'react';
import { AlertTypes } from '../../../../enums/alert.js';

const BaseAlert = (props)=>{
    const { children, className, tag = 'div', type = AlertTypes.Assertive, ...otherProps } = props;
    /**
   * Polite means the alert can wait until the screen reader user is finished with their current task
   * and not doing anything (such as stopped typing). A good example is search results count being spoken
   * after a user stops typing into a type="search" input and data is returned from a server.
   *
   * Assertive means the alert text should be spoken by a screen reader as soon as possible.
   * This should be reserved for UI elements like error messages, form validation messages,
   * and other situations where interruption is imperative.
   *
   * Our alerts have role="alert", which is shorthand for aria-live="assertive" with aria-atomic="true".
   * Adding `AlertTypes.Polite` (aria-live="polite") will delay announcing the alert text as described above.
   *
   * https://www.w3.org/TR/wai-aria-practices-1.2/#alert
   *
   * https://www.w3.org/TR/wai-aria/#aria-live
   *
   * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-live
   *
   * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-atomic
   *
   * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/alert_role
   */ const getType = ()=>{
        switch(type){
            case AlertTypes.Polite:
                {
                    return {
                        'aria-live': 'polite'
                    };
                }
            default:
                {
                    return {};
                }
        }
    };
    const Tag = tag;
    return /*#__PURE__*/ React.createElement(Tag, {
        ...otherProps,
        ...getType(),
        className: classnames('bf-alert', className),
        role: "alert"
    }, children);
};

export { BaseAlert };
//# sourceMappingURL=base-alert.js.map
